import { defaultTheme } from '../../../theming/data/defaultTheme'
import border from '../../../tokens/v2/border'
import layout from '../../../tokens/v2/layout'
import styled from 'styled-components'
import { composeTheme } from '../../../utils/compose-theme'

export const FooterMenu = styled.div.attrs((props) => composeTheme(props))`
  align-items: center;
  cursor: pointer;
  padding: ${layout.spacing.xxxs};
  background-color: ${(props) => props.theme.sideMenuAlt.background};
  justify-content: ${(props) => (props.theme.collapsed ? 'center' : 'left')};
`

export const Content = styled.button`
  border: ${border.width.none};
  background-color: transparent;
  display: flex;
  font: inherit;
  color: inherit;
  padding: ${layout.spacing.none};
  width: auto;
  cursor: pointer;
`

export const Link = styled.a`
  color: inherit;
  cursor: pointer;
  display: flex;
  font: inherit;
  text-decoration: none;
  width: auto;
`

FooterMenu.defaultProps = defaultTheme
